import { render, staticRenderFns } from "./SignupSubscription.vue?vue&type=template&id=585f6b92&lang=pug"
import script from "./SignupSubscription.vue?vue&type=script&lang=js"
export * from "./SignupSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports